import {
    GETBLOCKCOUNTRYLIST_SUCCESS,
    GETBLOCKCOUNTRYLIST_FAILED,
    RESET_GETBLOCKCOUNTRYLIST,
    LOADING_GETBLOCKCOUNTRYLIST,
    NETWORK_ERROR_GETBLOCKCOUNTRYLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetBlockCountryList = () => {
    return { type: RESET_GETBLOCKCOUNTRYLIST };
};

const getBlockCountryList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETBLOCKCOUNTRYLIST });
    await partnerServices
        .post("getBlockCountryList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getBlockCountryListsuccess(res.data));
                    break;
                default:
                    dispatch(getBlockCountryListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETBLOCKCOUNTRYLIST, payload: err });
        });
};
function getBlockCountryListsuccess(data) {
    return {
        type: GETBLOCKCOUNTRYLIST_SUCCESS,
        payload: data,
    };
}
function getBlockCountryListFailed(data) {
    return {
        type: GETBLOCKCOUNTRYLIST_FAILED,
        payload: data,
    };
}

export { resetGetBlockCountryList, getBlockCountryList };
